import React from "react";
import "./Pc.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import img11 from "../assets/11.png";
import { FaArrowCircleDown } from "react-icons/fa";

const steps = [
    {
        title: "Create an Account",
        description: "Sign up for a trading account if you haven’t already. Registration is quick and easy. Just contact us today. Our Support agents will help you to navigate and guide you to open an account."
    },
    {
        title: "Download the Terminal",
        description: "Ask our support agent to get the latest version of the Globus Trading PC Terminal or login to client cabinet after signup and you will have option of downloading the PC terminal."
    },
    {
        title: "Log In",
        description: "Use your credentials to log into the terminal and start exploring its features. When you signup with Globus trading, you will get the login credentials for client cabinet and also your trading account will be opened and you can login with your trading account and password to your PC terminal and start trading."
    },
    {
        title: "Fund Your Account",
        description: "Deposit funds to begin trading. We offer multiple funding options for your convenience. After login to your cabinet you will have the option to deposit funds in your trading account. We provide many payment options to fund your trading account. After adding the funds you can start the trading with Globus trading."
    }
];


const features = [
    {
        title: "Multi-Asset Trading",
        description: "Expand your trading horizons with access to forex, commodities, indices, and more. Trade multiple assets from a single platform, streamlining your trading activities."
    },
    {
        title: "In-Depth Analytics",
        description: "Leverage powerful analytical tools to gain deeper insights into market trends. Utilize our economic calendar, news feeds, and sentiment analysis to stay informed and ahead of the curve."
    },
    {
        title: "Customizable Indicators",
        description: "Enhance your trading strategy with a wide range of technical indicators. Customize and save your favorite setups to quickly apply them to new charts and market conditions."
    },
    {
        title: "Algorithmic Trading",
        description: "Create and backtest automated trading strategies using our integrated scripting tools. Fine-tune your algorithms to capitalize on market movements and optimize your trading performance."
    },
    {
        title: "Cross-Device Compatibility",
        description: "Start a trade on your PC and monitor it on the go with our cross-device compatibility. The Globus Trading Terminal syncs seamlessly with our mobile and web platforms, ensuring you stay connected wherever you are."
    },
    {
        title: "24/5 Customer Support",
        description: "Our dedicated support team is available around the clock to assist with any queries or issues. Benefit from professional guidance and technical support whenever you need it."
    }
];

const Pc = () => {
    return (
        <>
            <Navbar />

            {/* About Us Section */}
            <div className="pc-section">
                <h2 className="pc-title">Globus PC Terminal</h2>
            </div>

            {/* Section 1: Two Columns - Image Left, Details Right */}
            <div className="pc-container">
                <div className="pc-content">
                    <div className="pc-image">
                        <img src={img11} alt="Globus PC Terminal" />
                    </div>
                    <div className="pc-details">
                        <h2>Globus Trading PC Terminal:<br></br>
                            The Forex Trading at
                            Your Fingertips</h2>
                        <p>
                            Globus Trading PC Terminal, a cutting-edge platform designed to revolutionize your forex trading experience. Our terminal combines advanced technology, intuitive design, and robust features to empower traders at every level. Whether you’re a seasoned professional or a newcomer to the forex market, the Globus Trading PC Terminal offers the tools and functionalities you need to thrive.
                        </p>
                    </div>
                </div>
            </div>

            {/* Key Features Section */}
            <div className="features-section">
                <h2 className="features-title">Key Features of the Globus Trading PC Terminal</h2>
                <div className="features-grid">
                    {features.map((feature, index) => (
                        <div className="feature-box" key={index}>
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="pc-container2">
                <h2 className="pc-title2">Why Choose the Globus Trading PC Terminal?</h2>
                <p className="pc-subtitle2">
                    Choose the right PC terminal for your trading journey. We at Globus Trading provide the best and easiest-to-use PC terminal<br></br> to start your daily trading.
                </p>

                <div className="pc-conten2t">
                    <ul className="pc-list2">
                        <li>
                            Advanced Trading Tools
                            <p>Stay ahead in the fast-paced forex market with our comprehensive suite of trading tools. From real-time data analysis to customizable charting options, our terminal provides everything you need to make informed trading decisions.</p>
                        </li>
                        <li>
                            User-Friendly Interface
                            <p>The Globus Trading PC Terminal is designed with user experience in mind. Its intuitive interface ensures that you can focus on trading without getting bogged down by complicated menus or cluttered screens.</p>
                        </li>
                        <li>
                            Comprehensive Market Coverage
                            <p>Gain access to a vast range of forex pairs, including major, minor, and exotic currencies. Our terminal also supports trading in indices, commodities, and CFDs, giving you the flexibility to diversify your portfolio and explore new markets.</p>
                        </li>
                        <li>
                            Security You Can Trust
                            <p>Your peace of mind is our priority. The Globus Trading PC Terminal employs top-tier security protocols to protect your data and transactions. With encrypted connections and multi-factor authentication, you can trade with confidence knowing your information is safe.</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="get-started-section4">
                <h2>How to Get Started</h2>
                <p>Follow below steps to get started with our Globus Web Trader. You will get access to our Web Trader instantly.</p>

                <div className="steps-container">
                    <div className="step-box">
                        <div className="icon">⬇️</div>
                        <h3>Create an Account</h3>
                        <p>Sign up for a trading account if you haven’t already. Registration is quick and easy. Just contact us today. Our Support agents will help you to navigate and guide you to open account.</p>
                    </div>

                    <div className="step-box">
                        <div className="icon">⬇️</div>
                        <h3>Download the Terminal</h3>
                        <p>Ask our support agent to get the latest version of the Globus Trading PC Terminal or login to client cabinet after signup and you will have option of downloading the Pc terminal.</p>
                    </div>

                    <div className="step-box">
                        <div className="icon">⬇️</div>
                        <h3>Log In</h3>
                        <p>Use your credentials to log into the terminal and start exploring its features. When you signup with Globus trading, you will get the login credentials for client cabinet and also your trading account will be opened and you can login with your trading account and password to your pc terminal and start trading.</p>
                    </div>

                    <div className="step-box">
                        <div className="icon">⬇️</div>
                        <h3>Fund Your Account</h3>
                        <p>Deposit funds to begin trading. We offer multiple funding options for your convenience. After login to your cabinet you will have the option to deposit funds in your trading account. We provide many payment options to fund your trading account. After adding the funds you can start the trading with Globus trading.</p>
                    </div>
                </div>

                <h4 >Globus Pc Terminal</h4>
                <p>The Globus Trading PC Terminal is your gateway to a dynamic and efficient forex trading experience. With its advanced features, user-friendly design, and superior execution speeds, it’s the ideal tool for traders seeking to enhance their market performance. Download the terminal today and take the first step towards achieving your trading goals with Globus Trading.</p>
                
                <a className="btn primary4" href="https://globustrading.co/contact-us/">
                Contact Us Today  ➜
                        </a>
            </div>



            <Footer />
        </>
    );
};

export default Pc;
